import { createStandardAction } from 'typesafe-actions';

export const updateConstant = createStandardAction('CONSTANT_UPDATE')<
  AppConstant
>();
